<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'

import Loading from '@/components/Loading.vue'
import store from '@/store'
import http from '@/utils/http'
import { connectSocket } from '@/utils/web-socket'

export default {
  name: 'SetPasswordLogin',
  components: { Loading },
  mixins: [validationMixin],
  data() {
    return {
      changePassword: {
        password: null,
        confirmPassword: null,
      },
      sending: false,
    }
  },
  validations: {
    changePassword: {
      password: {
        required,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  computed: {
    user: {
      get() {
        return store.state.auth.user
      },
    },
  },
  async beforeMount() {
    if (store.state.auth.user.novaSenhaLogin === false) {
      await this.$router.push({ name: 'Home' })
    }
  },
  mounted() {
    this.$store.commit('setToolbarView', false)
  },
  beforeDestroy() {
    this.$store.commit('setToolbarView', true)
  },
  methods: {
    async handleSubmitChangeSenha() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.sending = true

      const data = await http.put('accounts/user/first-login/set-password', {
        password: this.changePassword.password,
        confirmPassword: this.changePassword.confirmPassword,
      })

      this.sending = false

      if (data) {
        await store.dispatch('login', {
          ...this.$store.state.auth,
          user: data,
        })
        connectSocket()

        await this.$router.push({ name: 'Home' })
      }
    },
    getValidationNewPassword(fieldName) {
      const field = this.$v.changePassword[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<template>
  <div>
    <Loading :loading="sending" />
    <!-- SENHA para editar -->
    <form v-if="!sending" novalidate @submit.prevent="handleSubmitChangeSenha">
      <div class="row" style="justify-content: center">
        <div class="col-sm-10 col-md-6">
          <p class="md-display-2">
            Olá, {{ user.nomeCompleto || user.userName }}!
          </p>

          <p class="md-title">
            Por favor, configure sua senha de primeiro acesso!
          </p>

          <p class="md-error" style="color: #ff1744">
            * Não compartilhe sua senha com ninguém, todas as ações relacionadas
            ao seu usuário são de sua responsabilidade.
          </p>

          <div>
            <md-field :class="getValidationNewPassword('password')">
              <label for="password">Senha</label>
              <md-input
                id="password"
                v-model="changePassword.password"
                name="password"
                type="password"
                :disabled="sending"
              />
              <span v-if="!$v.changePassword.password.required" class="md-error"
                >Senha é obrigatório</span
              >
            </md-field>

            <md-field :class="getValidationNewPassword('confirmPassword')">
              <label for="confirmPassword">Confirmar senha</label>
              <md-input
                id="confirmPassword"
                v-model="changePassword.confirmPassword"
                name="confirmPassword"
                type="password"
                :disabled="sending"
              />
              <span
                v-if="!$v.changePassword.confirmPassword.required"
                class="md-error"
                >Confirmar Senha é obrigatório</span
              >
              <span
                v-if="!$v.changePassword.confirmPassword.sameAsPassword"
                class="md-error"
              >
                A confirmação de senha é inválida
              </span>
            </md-field>
          </div>

          <md-progress-bar v-if="sending" md-mode="indeterminate" />

          <md-card-actions>
            <md-button
              type="submit"
              class="md-raised md-primary"
              :disabled="sending"
            >
              Salvar
            </md-button>
          </md-card-actions>
        </div>
      </div>
    </form>
  </div>
</template>

<style scoped lang="scss"></style>
